import { SMART_CONTRACT_TYPES } from "@/components/SmartContractDesigner/smartContractPluginIDs";
import { DiagramValidationErrorModel } from "../config/DiagramValidationErrorModel";
import { DIAGRAM_ERROR_TYPES } from "../config/DiagramErrorTypes";

export function DiagramHasContentCheck(data) {
    const isValid = Object.keys(data.pluginCounts).filter(key => key !== SMART_CONTRACT_TYPES.GENERAL_START_PLUGIN && key !== SMART_CONTRACT_TYPES.GENERAL_END_PLUGIN).find(key => data.pluginCounts[key] > 0) !== undefined;
    if (!isValid) {
        return [
            new DiagramValidationErrorModel({
                type: DIAGRAM_ERROR_TYPES.NO_CONTENT,
                reason: "Diagram has no content!"
            })
        ];
    }
    return true;
}
